import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import usePost from "../../hooks/api/usePost";
import InputField from "../../components/ui/form/InputField";
import Button from "../../components/ui/utils/Button";
import apiRequest from "../../utils/apiRequest";
import { setUserProfile } from "../../store/slice/globalStore";
import { useEffect } from "react";
import { HOME_ROUTE } from "../../routes/web/rootRoutes";

const PartnerProfile = () => {
  const userProfile = useSelector((state) => state.globalState.userProfile);
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.updateProfile);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      name: userProfile?.name || "",
      email: userProfile?.email || "",
      mobile: userProfile?.mobile || "",
      gst: userProfile?.gst || "",
      pincode: userProfile?.pincode || "",
      address: userProfile?.address || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email address").optional(),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Mobile number must be 10 digits")
        .required("Mobile number is required"),
    }),
    
    onSubmit: async (values) => {
      const response = await post({ data: { body: values } });      
      dispatch(setUserProfile(response?.data?.user));
   
    },
  });

  useEffect(() => {
    if (userProfile) {
      formik.setValues(userProfile);
    }
  }, [userProfile]);

  return (
    <div className="p-2 bg-white rounded-lg shadow-md">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-5">
          <h1 className="mb-6 text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-500 to-primary-200">
            Update Profile
          </h1>
          {error && <p className="text-red-500">{error}</p>}
          <div className="grid grid-cols-1 gap-4 mt-2 md:grid-cols-2">
            <InputField
              label="Name"
              id="name"
              type="text"
              placeholder="Enter name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.name && formik.errors.name}
              serverError={serverErrors?.name}
            />

            <InputField
              label="Email"
              id="email"
              type="email"
              placeholder="Enter email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && formik.errors.email}
              serverError={serverErrors?.email}
            />
              <InputField
                label="Mobile"
                id="mobile"
                type="text"
                placeholder="Enter mobile number"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.mobile && formik.errors.mobile}
                serverError={serverErrors?.mobile}
              />

              <InputField
              label="Gst No"
              id="gst"
              type="text"
              placeholder="Enter GST No."
              value={formik.values.gst}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.gst && formik.errors.gst}
              serverError={serverErrors?.gst}
            />
              <InputField
              label="Pin Code"
              id="pincode"
              type="text"
              placeholder="Enter pincode"
              value={formik.values.pincode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.pincode && formik.errors.pincode}
              serverError={serverErrors?.pincode}
            />
                <InputField
              label="Address"
              id="address"
              type="text"
              placeholder="Enter address"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.address && formik.errors.address}
              serverError={serverErrors?.address}
            />

          </div>
        </div>
        <div className="my-4 border-t border-gray-300"></div>
        <div className="flex items-center justify-end gap-4 p-4">
          <Button variant="primary" isLoading={loading} type="submit">
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default PartnerProfile;
